document.addEventListener('page:loaded', function () {

  $('body').on('click', '.cart_discount_modal', function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    $('[data-cart-popup]').addClass('active').fadeIn();
  });
  $('body').on('click', '.cart-popup-close', function (evt) {
    evt.preventDefault();
    evt.stopPropagation();
    $('[data-cart-popup]').removeClass('active').fadeOut();
    $('.cart_discount_modal').removeClass('btn--loading');
  });


  // only execute on product page
  if ($('.template-product').length === 0) return; 

  // console.log("productScript", "on product page");
  var request = new XMLHttpRequest();
  var productUrl = window.location.pathname + '.js';
  request.open('GET', productUrl, true);
  request.onload = function () {
    if (request.status >= 200 && request.status < 400) {
      // Success!
      var data = JSON.parse(request.responseText);
      // extract skus
      var skus = [];
      var arrayLength = data.variants.length;
      for (var i = 0; i < arrayLength; i++) {
        // console.log('sku-->', data.variants[i].sku);
        var sku_name = data.variants[i].sku;
        var sku_split = sku_name.split("-");
        if (sku_split[1] == 'B') {
          var skuVal = sku_split[0] + '-' + sku_split[2] + '-' + sku_split[3];
        } else {
          var skuVal = sku_split[0] + '-B-' + sku_split[1] + '-' + sku_split[2];
        }
        skus.push(skuVal);
      }
      // console.log('skus-->',skus);
      var searchURL = '/search?type=product&q=*' + skus[0] + '*';
      $.getJSON(searchURL + '&view=json', function (data) {
        if (data.results_count === 0) {
          return false;
        }
        var html = "";
        var productData = data.results[0];
        var sku = skus[0].split("-");
        var blind = false;
        if (sku[1] == 'B') {
          blind = true;
        }
        var titleText = '';
        if (blind == true) {
          titleText = theme.strings.relatedEngraveTitleBlind;
        } else {
          titleText = theme.strings.relatedEngraveTitleBlack;
        }
        html = `
          <a class="upsell-product" href="${productData.url}">
            <div class="grid__item medium-up--one-half upsell-img" style="background-image: url('${productData.thumbnail}');">
            </div>
            <div class="grid__item medium-up--one-half upsell-info">
              <h4 class="upsell-title">${titleText}</h4>
              <h5>${productData.title}</h5>
              <p>${productData.price}</p>
              <span class="btn btn--secondary">${theme.strings.relatedEngraveViewNowBtn}</span>
            </div>

          </a>
          `;

        $('#upsellProductContainer').append(html);
      });

      // Correct: Test override

    } else {
      // We reached our target server, but it returned an error
      console.warn("Could not load product json", request.status);
    }
  };
  request.onerror = function (error) {
    // There was a connection error of some sort
    console.warn("Error loading product json", productUrl, error);
  };
  request.send();

});
